module.exports = __webpack_public_path__ + "static/media/event6.b0f2b618.jpg";